import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CampsService } from '../camps.service';
import { CampsModel } from '../CampsModel';
import { CampsImagesModel } from '../CampsImagesModel';
import { EvaluationCampsModel } from '../EvaluationCampsModel';
import {EvaluationCampService} from '../evaluation-camp.service';
import { ReportModel } from '../../Reports/ReportModel';
import { ReportService } from '../../Reports/report.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CampItineraryModel } from '../CampItineraryModel';
import { CampIncludedModel } from '../CampIncludedModel';
@Component({
    // moduleId: module.id,
    selector: 'camps-details',
    templateUrl: 'camps-details.component.html',
    styleUrls: ['camps-details.component.scss']
})
export class CampsDetailsComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor( 
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :CampsService,
          private ReportService:ReportService,
          private route: ActivatedRoute,
          private EvaluationCampService: EvaluationCampService,
          ) {    
            this.Evaluation = [];
            this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         ngOnInit() {
          // this.lang = localStorage.getItem('theme_lang');
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.campingImagesList;
              this.includedList=this.modelObject.campIncludedList;
              this.itineraryList=this.modelObject.campItineraryList;
              this.EvaluationCampService.GetAllByCampIdId(this.id).subscribe(data=>{
                this.EvaluationCampList=data;
              })
              console.log("modelObject",this.rows)
              console.log("Images",this.files)
            })
          
  
          }
          else{
          }
  
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: CampsModel = new CampsModel();
      evaluationObject: EvaluationCampsModel = new EvaluationCampsModel();
      rows :CampsModel[]= [];


      EvaluationCampList :EvaluationCampsModel[]= [];
  
      mainForm: FormGroup = new FormGroup({
          id: new FormControl(),
          images: new FormControl(),
          title: new FormControl(),
          description: new FormControl(),
          latitude: new FormControl(),
          longitude: new FormControl(),
          countryId: new FormControl(),
          cityId: new FormControl(),
          userId: new FormControl(),
          date: new FormControl(),
      });
     
      EvaluationCampObject: EvaluationCampsModel = new EvaluationCampsModel();

      EvaluationCampForm: FormGroup = new FormGroup({
        id: new FormControl(),
        comment: new FormControl(),
        campId: new FormControl(),
        numberOfStars: new FormControl(),
        userId: new FormControl(),
        date: new FormControl(),
        time: new FormControl(),
       
    });

    // createEvaluationCampForm(EvaluationCampObject): FormGroup {
    //   debugger;
    //   return this.formBuilder.group({
    //     Id: [EvaluationCampObject.Id >= 0 ? EvaluationCampObject.Id : 0],
    //     comment: [EvaluationCampObject.comment >= 0 ? EvaluationCampObject.comment : 0],
    //     campId: [EvaluationCampObject.campId >= 0 ? EvaluationCampObject.campId : 0],
    //     numberOfStars: [EvaluationCampObject.numberOfStars >= 0 ? EvaluationCampObject.numberOfStars : 0],
    //     userId: [EvaluationCampObject.userId >= 0 ? EvaluationCampObject.userId : 0],
    //     date: [EvaluationCampObject.date >= 0 ? EvaluationCampObject.date : 0],
    //     time: [EvaluationCampObject.time >= 0 ? EvaluationCampObject.time : 0],
        
    //   });
    // }

        files:CampsImagesModel[]=[];

        public Evaluation:EvaluationCampsModel[]=[];
        public myComment: string ='';
        public myStars: number =0;
        public myTime: Date =new Date();
        public myDate: Date =new Date();

        goBack(){
          this.router.navigate(['/blimp/events']);
        }

        Save() {
          debugger;
          this.EvaluationCampObject = new EvaluationCampsModel();
          this.EvaluationCampObject.id = 0;
          this.EvaluationCampObject.comment = this.myComment;
          this.EvaluationCampObject.campId = this.id;
          this.EvaluationCampObject.numberOfStars = this.myStars;
          this.EvaluationCampObject.date = this.myDate;
          this.EvaluationCampObject.time = this.myTime;
          this.EvaluationCampObject.userId = 0;
          this.EvaluationCampObject.isHide = false;
          console.log(this.modelObject);
          console.log(this.modelObject);
          this.EvaluationCampService.insert(this.EvaluationCampObject).subscribe((data) => {
            this.myComment='';
            this.myStars=0;
            this.ngOnInit();
            // this.router.navigate(["app/HR/List-Salaries-Manager"]);
          });
        }

        ReportObject:ReportModel=new ReportModel();
    ReportForm:FormGroup=new FormGroup({
    id: new FormControl(),
    message: new FormControl(),
    commentId: new FormControl(),
    userId: new FormControl(),
    });
    public message: string ='';
    commetId=0;
    setCommentId(commetId){
      this.commetId =commetId;

    }
  @ViewChild('closebutton') closebutton;

      SendReport() {
        debugger;
        this.ReportObject = new ReportModel();
        this.ReportObject.id = 0;
        this.ReportObject.message = this.message;
        this.ReportObject.commentId = this.commetId;
        this.ReportObject.userId = 0;
        this.ReportObject.Type = 'camps';
        console.log(this.modelObject);
        this.ReportService.insert(this.ReportObject).subscribe((data) => {
          this.message='';
          this.commetId=0;
          this.closebutton.nativeElement.click();
          // this.ngOnInit();
        });
      }

    selectedImages:CampsImagesModel={};
    itineraryList:CampItineraryModel[]=[];
    includedList:CampIncludedModel[]=[];
        setImage(EventId){
          debugger;
          var i = this.files.findIndex(x=>x.campingId == this.id);
          if(i>-1){
            this.selectedImages = this.files[i];
          }
          else{
            this.selectedImages.imageURL=''
          }
          
        }
        ratingChanged($event){

        }


        customOptions: OwlOptions = {
          // loop: true,
          mouseDrag: true,
          touchDrag: true,
          pullDrag: false,
          // autoplay: true,
          navSpeed: 700,
          navText: ['', ''],
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 3
            },
            900: {
              items: 4
            }
          },
          nav: false
        };

        customOptions2: OwlOptions = {
          // loop: true,
          mouseDrag: true,
          touchDrag: false,
          pullDrag: false,
          // autoplay: true,
          margin: 15,
          navSpeed: 200,
          navText: ['', ''],
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 1
            },
            900: {
              items: 3
            }
          },
          nav: false
        };
        
}
